import React from 'react';
const BannerTen = () => {
  // Function to handle smooth scrolling to sections
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };
  
  return (
    <>
      {/* page title start */}
      <div className="banner-area bg-relative banner-area-2 bg-cover">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <div className="banner-inner banner-inner-home-eleven pe-xl-5">
                <h1
                  className="title wow animated fadeInLeft"
                  data-wow-duration="1.5s"
                  data-wow-delay="0.3s"
                >
                  Firma tus documentos de forma segura sin necesidad de gastar en papel
                </h1>
                <p
                  className="subtitle wow animated fadeInLeft"
                  data-wow-duration="1.5s"
                  data-wow-delay="0.4s"
                >
                  Firma electrónica sencilla y segura, con validación real de identidad.
                </p>
                
                {/* Trust bullets */}
                <div className="trust-bullets mb-4">
                  <ul className="list-unstyled">
                    <li className="d-flex align-items-center mb-2">
                      <span className="check-icon me-2">✓</span>
                      Verificación de identidad con código OTP (5 min de vigencia)
                    </li>
                    <li className="d-flex align-items-center mb-2">
                      <span className="check-icon me-2">✓</span>
                      Pistas de auditoría: IP, fecha y hora por firmante
                    </li>
                    <li className="d-flex align-items-center mb-2">
                      <span className="check-icon me-2">✓</span>
                      PDF final con QR para validar la integridad
                    </li>
                  </ul>
                </div>
                
                <div className="banner-buttons">
                  <button
                    onClick={() => scrollToSection('contacto')}
                    className="btn btn-base me-3 wow animated fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.6s"
                  >
                    Comenzar ahora
                  </button>
                  <button
                    onClick={() => scrollToSection('como-funciona')}
                    className="btn btn-border-base wow animated fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.6s"
                  >
                    Ver cómo funciona
                  </button>
                </div>
                
                {/* Social proof */}
                <div className="social-proof mt-4">
                  <p className="text-muted">
                    "Pensado para RR.HH., legal y operaciones."
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-lg-6 col-md-9 wow animated fadeInRight"
              data-wow-duration="1.5s"
              data-wow-delay="0.3s"
            >
              <div className="banner-thumb-2 mt-4 mt-lg-0">
                <img
                  className="banner-animate-img banner-animate-img-4"
                  src="assets/img/home-11/fcheck1.png"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* banner end */}
    </>
  );
};

export default BannerTen;
